// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__tN6TL","title":"styles_title__Ongn3","description":"styles_description__KJQxd","content":"styles_content__JQXLO"};